import { useRef } from "react";
import { usePhoneInput, defaultCountries, parseCountry, FlagImage } from "react-international-phone";
import "react-international-phone/style.css";
import Popper from "@fragments/Popper";
import InfoRounded from "@mui/icons-material/InfoRounded";

const PhoneInput = ({
    value,
    onInput,
    label = "Telefone",
    placeholder = "",
    variant = "light",
    disabled,
    error,
    helper,
    fullWidth,
    className,
}) => {
    const popperRef = useRef(null);
    const countryBtnRef = useRef(null);
    const inputRef = useRef(null);

    const { inputValue, handlePhoneValueChange, country, setCountry } = usePhoneInput({
        defaultCountry: "br",
        value: value || "",
        countries: defaultCountries,
        onChange: ({ phone }) => onInput && onInput(phone),
    });

    function handleOpenCountryPopper() {
        if (!popperRef.current || !countryBtnRef.current) return;

        const options = defaultCountries.map((c) => {
            const { name, iso2, dialCode } = parseCountry(c);
            return {
                id: iso2,
                label: `${name} (+${dialCode})`,
                icon: <FlagImage iso2={iso2} size="18px" style={{ borderRadius: 2, flexShrink: 0 }} />,
                onClick: () => {
                    setCountry(iso2);
                    setTimeout(() => inputRef.current?.focus(), 100);
                },
            };
        });

        popperRef.current.open(options, "bottom-start", countryBtnRef.current);
    }

    return (
        <Popper
            controlRef={popperRef}
            config={{
                searchKeyExtractor: (opt, validate) => validate(opt.label),
            }}
        >
            <div
                className={[
                    "CustomInput_container",
                    disabled ? "disabled" : "",
                    error ? "error" : "",
                    className || "",
                    variant === "large" ? "large" : "small",
                    fullWidth ? "full-width" : "",
                ]
                    .filter(Boolean)
                    .join(" ")}
                style={{ position: "relative" }}
            >
                {label && <span className="CustomInput_label">{label}</span>}

                <div className="CustomInput_platform-input-base">
                    {/* Country selector — triggers Popper */}
                    <span
                        ref={countryBtnRef}
                        className="input-icon input-start-icon phone-country-selector"
                        onClick={disabled ? undefined : handleOpenCountryPopper}
                        style={{ cursor: disabled ? "default" : "pointer" }}
                    >
                        <FlagImage
                            iso2={country.iso2}
                            size="20px"
                            style={{ borderRadius: 2, display: "block", flexShrink: 0 }}
                        />
                    </span>

                    <input
                        ref={inputRef}
                        value={inputValue}
                        onChange={handlePhoneValueChange}
                        type="tel"
                        placeholder={placeholder}
                        disabled={disabled}
                        className={`custom-input custom-input-${variant}`}
                    />
                </div>

                {helper && (
                    <div className="CustomInput_bottom">
                        <span className="CustomInput_helper">
                            <InfoRounded />
                            <span>{helper}</span>
                        </span>
                    </div>
                )}
            </div>
        </Popper>
    );
};

export default PhoneInput;
